import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Formik } from "formik";

import { useCatchmentExportMutation } from "@/app/catchment/catchment.api";
import { CatchmentRequest } from "@/app/catchment/catchment.types";
import TabsUI from "@/shared/components/atoms/TabsUI";

import { StockStore } from "./components/StockStore";
import { Store } from "./components/Store";
import { Permission } from "@/shared/hooks/usePermission";

export const initialValues: CatchmentRequest = {
  search: "",
  branch_filter: null,
  sex_filter: null,
  campaign_filter: null,
  stages_filter: null,
  stages_users_filter: null,
  tag_marketing_filter: null,
  catchment_page: "store",
};

export const StorePage = () => {
  const [formValues, setFormValues] = useState(initialValues);

  const [t] = useTranslation();

  const tabs = [
    {
      id: "store",
      name: t("store.views.tabs.sell_products"),
      permission: Permission.SELL_PRODUCTS_STORE_TAB,
    },
    {
      id: "stock",
      name: t("store.views.tabs.manage_stock"),
      permission: Permission.SELL_PRODUCTS_STORE_TAB,
    },
  ];

  const [catchmentExport] = useCatchmentExportMutation();

  return (
    <Formik
      initialValues={initialValues}
      validate={(values) => setFormValues(values)}
      onSubmit={() => {}}
    >
      {({ values, setFieldValue }) => {
        return (
          <div className="flex-1 overflow-x-hidden overflow-y-scroll">
            <div className="px-4">
              <TabsUI
                tabs={tabs}
                handleChange={(tab) => setFieldValue("catchment_page", tab)}
                current={values.catchment_page}
              />
            </div>
            <div className="mt-1">
              {values.catchment_page === "store" && (
                <>
                  <Store
                    onOpenStock={() => setFieldValue("catchment_page", "stock")}
                  />
                </>
              )}
              {values.catchment_page === "stock" && (
                <>
                  <StockStore />
                </>
              )}
            </div>
          </div>
        );
      }}
    </Formik>
  );
};
